import Phaser from 'phaser';
import { saveManager } from '../core/SaveManager';

/** Apply the commander-selected readability multiplier to the current scene. */
export function applyUiTextScale(scene: Phaser.Scene): void {
  const scale = Phaser.Math.Clamp(Number(saveManager.data.settings.uiTextScale ?? 1), 0.8, 1.35);
  const apply = (object: Phaser.GameObjects.GameObject): void => {
    const text = object as Phaser.GameObjects.Text;
    if (text.type === 'Text' && typeof text.setScale === 'function') {
      // Phaser rasterises Text into a texture. A higher backing resolution
      // keeps small tactical labels legible when the 1280px canvas is fitted
      // into a narrower browser window at a fractional scale.
      text.setResolution(Math.max(2, text.style.resolution || 1));
      const original = Number(text.getData('apogeeUiBaseScale') ?? text.scaleX ?? 1);
      text.setData('apogeeUiBaseScale', original);
      text.setScale(original * scale);
    }
    const container = object as Phaser.GameObjects.Container;
    if (Array.isArray(container.list)) container.list.forEach((child) => apply(child));
  };
  scene.children.list.forEach((object) => apply(object));
}
